import { computed } from 'vue';

import type {
  GetTranslationFuncReactive,
} from '@modules/i18n/types';
import { getApp } from '@modules/core/app/utils';
import { useFrontendLocalesStore } from '@modules/i18n/store';

export interface I18nComposable {
  getTranslation: GetTranslationFuncReactive;
  getTPath(groupKey: symbol, shortCode: string): string;
}

export default function useI18n(): I18nComposable {
  const { getTPath } = useFrontendLocalesStore();

  const getTranslation: GetTranslationFuncReactive = (group, shortKey, options) => (
    computed(() => getApp().config.globalProperties.$t(getTPath(group, shortKey), options))
  );

  return {
    getTranslation,
    getTPath,
  };
}
